import './scss/EnteteAccueil.scss';

export default function EnteteAccueil(props)
{
    return(
        <>
            <header className="EnteteAccueil">
                <h2 className="nom">Julian Maldonado</h2>
            </header>
        </>
    );
}